const getters = {
  language: state => state.app.language,
  token: state => state.user.token,
  name: state => state.user.name,
  role: state => String(state.user.role),
  id: state => state.user.id,
  station: state => JSON.parse(state.station.info),
  control: state => Number(state.station.control),
  gtypes: state => JSON.parse(state.station.gtypes)
}

export default getters
